import React, { useEffect, useRef, useState } from 'react';
import './OfflineBanner.css';

/**
 * A site-wide connection notice. Families use this on hospital wifi and in
 * parking lots — a silent failure on "Send" is worse than a banner.
 */
const OfflineBanner = () => {
  const [online, setOnline] = useState(
    typeof navigator === 'undefined' ? true : navigator.onLine
  );
  const [justReconnected, setJustReconnected] = useState(false);
  const wasOffline = useRef(!online);

  useEffect(() => {
    const goOnline = () => {
      setOnline(true);
      if (wasOffline.current) {
        setJustReconnected(true);
        window.setTimeout(() => setJustReconnected(false), 4000);
      }
      wasOffline.current = false;
    };
    const goOffline = () => {
      wasOffline.current = true;
      setOnline(false);
      setJustReconnected(false);
    };
    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);
    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);

  if (online && !justReconnected) return null;

  return (
    <div
      className={`offline-banner ${online ? 'is-back' : 'is-down'}`}
      role="status"
      aria-live="polite"
    >
      {online
        ? 'Back online.'
        : "You're offline. Anything you send will wait until your connection is back."}
    </div>
  );
};

export default OfflineBanner;
